import { OrderStatusScreen } from '../../../../screens';

// ─────────────────────────────────────────────────────────────────────────────

export default function Page() {
  return <OrderStatusScreen />;
}
